export default __webpack_public_path__ + "static/media/007-pet-house.50b300ea.png";